import type { SiteMembersRefs } from './types'
import { getSiteFeatureBoundRefProvider } from '../../utils/refProvider'

const featureName = 'siteMembers'
const siteMembersRefProvider = getSiteFeatureBoundRefProvider(featureName)

const siteMembersRefs: SiteMembersRefs = {
	promptLogin: () => siteMembersRefProvider(['promptLogin']),
	logout: () => siteMembersRefProvider(['logout']),
	memberDetails: () => siteMembersRefProvider(['memberDetails']),
}

export { siteMembersRefs }
